import { IconButton, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, TextField, useTheme, Box, Typography, FormControl, Divider, Button, Autocomplete,alpha  } from "@mui/material";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";

import { useEffect, useState } from "react";
import useGetMAWiseBalancePlanQty from "../../../hooks/useGetMAWiseBalancePlanQty";
import CustomPagination from "../../../components/table/CustomPagination";

import DownloadIcon from '@mui/icons-material/Download'; // or DownloadOutlined
import Close from '@mui/icons-material/Close';
import * as XLSX from "xlsx";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import GlobalConfig from "../../../config/date/GlobalConfig";
import dayjs from "dayjs";
import { tokens } from "../../../theme/theme";


const ReportParentRollProductionMAWiseBalanceQty = ({ handleBackWinderMachineEntry, mode }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const { maWiseDetail, setMAWiseDetail, isDataLoaded, setIsDataLoaded, loading, loadDetailWithoutDate, loadDetailWithDate } = useGetMAWiseBalancePlanQty();

    // skeleton progress 
    // const [loading, setLoading] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [selectedStatus, setSelectedStatus] = useState('All');

    const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [filterToDate, setFilterToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [partyList, setPartyList] = useState([]);


    const handleFilterFromDate = (date) => {
        setFilterFromDate(dayjs(date));
    };

    const handleFilterToDate = (date) => {
        setFilterToDate(dayjs(date));
    };

    // fetch data
    useEffect(() => {

        if (filterFromDate !== '' && filterToDate !== '') {
            const p_companyid = localStorage.getItem('companyid');
            const payload = {
                p_companyid: p_companyid,
                p_plantid: 1,
                p_frommodate: dayjs(filterFromDate).format('YYYY-MM-DD hh:mm:ss'), // ISO format for PostgreSQL timestamp
                p_tomodate: dayjs(filterToDate).format('YYYY-MM-DD hh:mm:ss'),
                p_mode: 1,
            }
            loadDetailWithDate(payload);
        }
    }, [filterFromDate, filterToDate])

    const handleWithoutDateRange = async () => {
        const p_companyid = localStorage.getItem('companyid');
        const payload = {
            p_companyid: p_companyid,
            p_plantid: 1,
            p_frommodate: dayjs(filterFromDate).format('YYYY-MM-DD hh:mm:ss'), // ISO format for PostgreSQL timestamp
            p_tomodate: dayjs(filterToDate).format('YYYY-MM-DD hh:mm:ss'),
            p_mode: 0,
        }
        loadDetailWithoutDate(payload);
    }
    const [filters, setFilters] = useState({
        item_code: '',
        gsm: '',
        release_no: '',
        lot_no: '',
        co_qty: '',
        prod_qty: '',
        balance_qty: '',
        set_no: '',
    });


    // Calculate the number of pages
    const pageCount = Math.ceil(maWiseDetail.length / recordsPerPage);

    const filteredData = maWiseDetail.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };




    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleExportToExcel = () => {
        // Prepare the data with headers
        const formattedData = filteredData.map(row => ({
            "QUALITY": row.item_code,
            "GSM": row.gsm || '',
            "MO NUMBER": row.release_no,
            "MA NUMBER": row.lot_no,
            "DECKLE QTY": row.co_qty,
            "PRODUCTION QTY": row.prod_qty,
            "BALANCE QTY": row.balance_qty,
            "NO OF SET": row.set_no,
        }));

        // Create a new worksheet with headers
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Get the range of the worksheet to apply styles
        const range = XLSX.utils.decode_range(worksheet['!ref']);

        // Apply styling to headers
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col }); // Row 0 (header row)
            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                alignment: {
                    vertical: 'center',
                    horizontal: 'center',
                },
                font: {
                    bold: true,
                },
                border: {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' },
                },
            };
        }

        // Apply borders to all cells
        for (let row = range.s.r; row <= range.e.r; row++) {
            for (let col = range.s.c; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (!worksheet[cellAddress]) continue;

                worksheet[cellAddress].s = {
                    ...worksheet[cellAddress].s,
                    border: {
                        top: { style: 'thin' },
                        bottom: { style: 'thin' },
                        left: { style: 'thin' },
                        right: { style: 'thin' },
                    },
                };
            }
        }

        // Create a new workbook and append the styled worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "MA WISE DETAIL");

        // Get current date and time in ddmmyyyy and HHMM format
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        // Format filename as ddmmyyyy_HHMM
        const dateTime = `${day}${month}${year}_${hours}${minutes}`;
        const fileName = `MA WISE BALANCE QTY REPORT.xlsx`;

        // Export the file
        XLSX.writeFile(workbook, fileName);
    };

    const handleCallBack = () => {
        handleBackWinderMachineEntry();
    }

    // Assuming filters and handleFilterChange are already defined
    // You must also extract unique options for each autocomplete column
    const uniqueValues = {
        item_code: [...new Set(maWiseDetail.map(row => row.item_code))],
        gsm: [...new Set(maWiseDetail.map(row => row.gsm))],
        release_no: [...new Set(maWiseDetail.map(row => row.release_no))],
        lot_no: [...new Set(maWiseDetail.map(row => row.lot_no))]
    };

    return (
        <>
       
            <Divider />
            <Grid container padding="5px 0px 5px 0px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                <Divider orientation="vertical" flexItem sx={{ mx: 0.1 }} />
                <Box marginRight="auto" marginLeft={1}>
                    {/* <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >View MA Wise Balance Planning Qty</Typography> */}
                </Box>

                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1.2} mt="5px">
                    <FormControl fullWidth size="small">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                style={{ marginLeft: '10px' }}
                                id="FromDate"
                                value={dayjs(filterFromDate)}
                                onChange={(date) => handleFilterFromDate(date)}

                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'standard', // Removes the filled/outlined border
                                        InputProps: {
                                            disableUnderline: true, // Remove underline from 'standard' variant
                                        },
                                        sx: {
                                            backgroundColor: 'transparent',
                                            padding: 0,
                                            '& .MuiInputBase-root': {
                                                border: 'none',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '18px', // 👈 smaller icon size
                                            },
                                            '& .MuiInputBase-root': {
                                                paddingRight: '6px', // optional: reduce padding around icon
                                            },
                                        },
                                    }
                                }}
                                renderInput={(props) => <TextField {...props} />}
                                autoFocus
                                format="DD-MMM-YYYY"
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>

                <Grid item mt="2px" ml="10px" mr="10px">
                    <Typography fontWeight="bold">-</Typography>
                </Grid>

                <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1.2} mt="5px" mr="10px">
                    <FormControl fullWidth size="small" >
                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                            <DatePicker
                                id="ToDate"
                                value={dayjs(filterToDate)}
                                format="DD-MMM-YYYY"
                                onChange={(date) => handleFilterToDate(date)}

                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'standard', // Removes the filled/outlined border
                                        InputProps: {
                                            disableUnderline: true, // Remove underline from 'standard' variant
                                        },
                                        sx: {
                                            backgroundColor: 'transparent',
                                            padding: 0,
                                            '& .MuiInputBase-root': {
                                                border: 'none',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '18px', // 👈 smaller icon size
                                            },
                                            '& .MuiInputBase-root': {
                                                paddingRight: '6px', // optional: reduce padding around icon
                                            },
                                        },
                                    }
                                }}
                                renderInput={(props) => <TextField {...props} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                <Grid item mt="2px" ml="5px" mr="5px">
                    <Button size="small" variant="contained" color="secondary" onClick={() => { handleWithoutDateRange() }}>Fetch Data Without Date Range</Button>
                </Grid>

                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                <Grid item mt="2px" ml="5px" mr="5px">
                    <IconButton onClick={handleExportToExcel}>
                        <DownloadIcon />
                    </IconButton>
                </Grid>
                <Divider orientation="vertical" flexItem />
                {mode === 0 && (
                    <>
                        <Grid item mt="2px" ml="5px" mr="5px" justifyContent="center">
                            <IconButton onClick={() => { handleCallBack() }}>
                                <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                            </IconButton>
                        </Grid>
                        <Divider orientation="vertical" flexItem />
                    </>
                ) || (null)}
            </Grid>

            <Divider />
            <CustomTableContainer colors={colors}>
                <TableContainer >
                    {loading ? (
                        <SkeletonTableLoader rows={10} columns={6} />
                    ) : (
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>MO NUMBERS</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>MA NUMBERS</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>DECKLE QTY</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>PRODUCTION QTY</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>BALANCE QTY</TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>NO OF SET</TableCell>


                                </TableRow>
                                {/* Filter Row */}
                                {/* <TableRow>
                                    {['item_code', 'gsm', 'release_no', 'lot_no', 'co_qty', 'prod_qty', 'balance_qty', 'set_no'].map((col) => (
                                        <TableCell key={col} sx={{ padding: '4px' }}>
                                            <input
                                                type="text"
                                                value={filters[col]}
                                                onChange={(e) => handleFilterChange(e, col)}
                                                style={{ width: '100%', padding: '2px', fontSize: '0.8rem' }}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow> */}

                                <TableRow>
                                    {['item_code', 'gsm', 'release_no', 'lot_no', 'co_qty', 'prod_qty', 'balance_qty', 'set_no'].map((col) => (
                                        <TableCell key={col} sx={{ padding: '4px' }}>
                                            {['item_code', 'gsm', 'release_no', 'lot_no'].includes(col) ? (
                                                <Autocomplete
                                                    freeSolo
                                                    options={uniqueValues[col] || []}
                                                    value={filters[col] || ''}
                                                    onInputChange={(event, newValue) => handleFilterChange({ target: { value: newValue } }, col)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Filter"
                                                            variant="standard"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                disableUnderline: true
                                                            }}
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                                // backgroundColor: '#f5f5f5',
                                                                borderRadius: 1,
                                                                px: 1,
                                                            }}
                                                        />
                                                    )}
                                                />

                                            ) : (
                                                <TextField
                                                    variant="standard"
                                                    value={filters[col] || ''}
                                                    onChange={(e) => handleFilterChange(e, col)}
                                                    placeholder="Filter"
                                                    fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                    sx={{
                                                        fontSize: '0.75rem',
                                                        //   backgroundColor: '#f5f5f5',
                                                        borderRadius: 1,
                                                        px: 1,
                                                    }}
                                                />

                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>



                            </TableHead>
                            <TableBody>
                                {currentRecords.map((row, index) => (
                                    <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                        <TableCell sx={{ textAlign: "center" }}>{row.item_code}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {/* <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                             onClick={() => handleCallEdit(row.id, row.pr_number, row.status)}
                                            > */}
                                            {row.gsm}
                                            {/* </span> */}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{row.release_no}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{row.lot_no}</TableCell>
                                        <TableCell sx={{ textAlign: "right" }}>{row.co_qty}</TableCell>
                                        <TableCell sx={{ textAlign: "right" }}>{row.prod_qty} </TableCell>
                                        <TableCell sx={{ textAlign: "right" }}>{row.balance_qty}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{row.set_no}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                    <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
                </TableContainer>
            </CustomTableContainer>

        </>
    )
}
export default ReportParentRollProductionMAWiseBalanceQty;